import {useUpmPlantContext} from '@hconnect/upm'
import {FeatureFlagConfig, useFeatureFlagsQuery} from '@hproduce/feature-flags'
import {usePermissionsParsedQuery} from '@hproduce/permissions'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {Navigate} from 'react-router'

import {PlannerPageSkeleton} from '../../shared/components/skeletons/PlannerPageSkeleton'
import {Log} from '../../shared/Log'
import {getPageAvailability} from '../../shared/permissions'
import {getUrl} from '../helpers'

const log = Log.context('DefaultPageRedirect')

export const DefaultPageRedirect: React.FC = () => {
  const {t} = useTranslation()
  const {plantId: plantCode, country: countryId} = useUpmPlantContext()
  const {data: featureFlags} = useFeatureFlagsQuery({
    configurationName: FeatureFlagConfig.Suite,
    params: {plantId: plantCode}
  })
  const {data: permissions} = usePermissionsParsedQuery()

  if (!featureFlags || !permissions) {
    return <PlannerPageSkeleton />
  }

  const pageAvailability = getPageAvailability(featureFlags, permissions, countryId, plantCode)

  const availableMainRoutes = pageAvailability.filter(
    (availabilityDetail) => availabilityDetail.isAvailable && availabilityDetail.hasPermission
  )

  if (availableMainRoutes.length === 0) {
    const errorMessage = t('error.notAbleToForwardToThePage')
    log.extras({plantCode}).critical(errorMessage)
    throw new Error(errorMessage)
  }

  const [defaultRoute] = availableMainRoutes

  return <Navigate to={getUrl(defaultRoute.path, {plantCode})} replace />
}
